// src/components/shared/Card.jsx  
import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ 
  children, 
  className = '', 
  gradient = false, 
  hover = false,
  padding = 'p-6',
  onClick = null,
}) => {
  const baseClasses = 'rounded-xl border border-purple-200/20 backdrop-blur-sm';
  const gradientClasses = gradient 
    ? 'bg-gradient-to-br from-purple-900/20 to-indigo-900/20' 
    : 'bg-white/5';
  const hoverClasses = hover 
    ? 'hover:bg-white/10 hover:border-purple-200/40 hover:shadow-lg hover:shadow-purple-500/10 transition-all duration-300' 
    : '';
  const clickableClasses = onClick ? 'cursor-pointer' : '';
  
  const CardComponent = onClick ? motion.div : 'div';
  const motionProps = onClick ? {
    whileHover: { y: -2 },
    whileTap: { scale: 0.98 },
  } : {};
  
  return (
    <CardComponent
      {...motionProps}
      onClick={onClick}
      className={`${baseClasses} ${gradientClasses} ${hoverClasses} ${clickableClasses} ${padding} ${className}`}
    >
      {children}
    </CardComponent>
  );
};

export default Card;